export default {
  // Navigation
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.retreat_details': 'Retreat Details',
  'nav.experiences': 'Experiences',
  'nav.schedule': 'Schedule',
  'nav.reserve': 'Reserve',

  // Hero Section
  'hero.label': 'Wellness Retreat',
  'hero.title': 'Swasthya',
  'hero.subtitle': 'Where Ancient India Meets Island Healing',
  'hero.tagline': 'Reconnect, Restore & Rebalance in Fuerteventura',
  'hero.description': 'Discover a 3-night, 4-day retreat that harmonizes your mind, body, and soul through the wisdom of ancient Indian wellness traditions, set in the serene landscapes of Fuerteventura.',
  'hero.cta': 'Begin Your Journey',

  // About Section
  'about.label': 'Discover Swasthya',
  'about.title': 'Why Swasthya is Unique',
  'about.expert.title': 'Expert Guidance',
  'about.expert.description': 'A team of specialists from India and Spain, blending Ayurveda, yoga, pranayama, and heart-centered practices with nature and water-based experiences.',
  'about.holistic.title': 'Holistic Healing',
  'about.holistic.description': 'Dosha-balancing Ayurvedic therapies, sattvic cuisine, yoga, meditation, and mindful movement to restore your energy and vitality.',
  'about.nature.title': 'Nature Immersion',
  'about.nature.description': 'Experience mindful connection with beaches, dunes, and winds, enhancing your wellness journey through Fuerteventura\'s natural beauty.',
  'about.personalized.title': 'Personalized Approach',
  'about.personalized.description': 'Every practice and treatment is tailored to your unique constitution, ensuring maximum balance and rejuvenation for your individual needs.',
  'about.founder.intro': 'The Swasthya Retreat is led by',
  'about.founder.name': 'Mala Krishnani',
  'about.founder.description': ', a holistic wellness visionary from India. With over 20 years of experience as a yoga teacher, she is also an acupressure and acupuncture specialist, Reiki and Suzok master, Ayurveda expert, and Vipassana retreat facilitator, and has taught extensively across India, the Middle East, and Europe. She blends traditional Indian wisdom with holistic practices to guide a transformative mind-body experience.',
  'about.closing': 'At Swasthya, we believe that true wellness comes from the harmonious integration of ancient wisdom with modern understanding. Our retreat is designed to provide you with the tools, knowledge, and experiences needed to continue your wellness journey long after you return home.',

  // Retreat Details Section
  'retreat.title': 'Retreat Details',
  'retreat.subtitle': 'Your Transformation Journey',
  'retreat.duration.title': 'Duration',
  'retreat.duration.description': '7, 14, or 21-day retreats designed for deep transformation',
  'retreat.accommodation.title': 'Accommodation',
  'retreat.accommodation.description': 'Luxury private villas with nature views and modern amenities',
  'retreat.meals.title': 'Meals',
  'retreat.meals.description': 'Three organic sattvic meals daily tailored to your dosha',
  'retreat.treatments.title': 'Treatments',
  'retreat.treatments.description': 'Daily Ayurvedic therapies including Abhyanga, Shirodhara, and Panchakarma',
  'retreat.yoga.title': 'Yoga & Meditation',
  'retreat.yoga.description': 'Daily yoga, pranayama, and guided meditation sessions',
  'retreat.consultation.title': 'Consultations',
  'retreat.consultation.description': 'Personalized assessments with certified Ayurvedic practitioners',

  // Experiences Section
  'experiences.title': 'Transformative Experiences',
  'experiences.subtitle': 'Ancient Healing Therapies',
  'experiences.abhyanga.title': 'Abhyanga',
  'experiences.abhyanga.description': 'Traditional full-body massage with warm herbal oils to detoxify and rejuvenate',
  'experiences.shirodhara.title': 'Shirodhara',
  'experiences.shirodhara.description': 'Continuous stream of warm oil over the forehead to deeply calm the mind',
  'experiences.panchakarma.title': 'Panchakarma',
  'experiences.panchakarma.description': 'Comprehensive five-step detoxification program for deep purification',
  'experiences.yoga.title': 'Yoga & Pranayama',
  'experiences.yoga.description': 'Daily practices to balance energy and enhance vitality',
  'experiences.meditation.title': 'Guided Meditation',
  'experiences.meditation.description': 'Mindfulness sessions for inner peace and mental clarity',
  'experiences.nutrition.title': 'Ayurvedic Nutrition',
  'experiences.nutrition.description': 'Personalized meals prepared according to your unique constitution',

  // Schedule Section
  'schedule.title': 'Daily Schedule',
  'schedule.subtitle': 'A Day at Swasthya',
  'schedule.morning.title': 'Morning Routine',
  'schedule.morning.time': '6:00 AM - 9:00 AM',
  'schedule.morning.activities': 'Early wake-up, Yoga & Pranayama, Meditation, Sattvic breakfast',
  'schedule.midday.title': 'Midday Session',
  'schedule.midday.time': '9:00 AM - 1:00 PM',
  'schedule.midday.activities': 'Ayurvedic consultation, Therapeutic treatments, Free time for reflection',
  'schedule.afternoon.title': 'Afternoon',
  'schedule.afternoon.time': '1:00 PM - 6:00 PM',
  'schedule.afternoon.activities': 'Nourishing lunch, Rest and relaxation, Nature walk or optional activities',
  'schedule.evening.title': 'Evening Ritual',
  'schedule.evening.time': '6:00 PM - 9:00 PM',
  'schedule.evening.activities': 'Gentle yoga, Light dinner, Guided meditation, Silent time',

  // Accommodation Gallery Section
  'accommodation.title': 'Our Villas',
  'accommodation.subtitle': 'Luxury Sanctuaries Inspired by the Five Elements',
  'accommodation.tierra.name': 'Villa Tierra',
  'accommodation.tierra.element': 'Earth Element',
  'accommodation.tierra.description': 'Grounded in stability and nourishment, this villa offers a serene refuge with earthy tones and natural materials.',
  'accommodation.fuego.name': 'Villa Fuego',
  'accommodation.fuego.element': 'Fire Element',
  'accommodation.fuego.description': 'Igniting transformation and energy, featuring warm colors and vibrant spaces that inspire passion.',
  'accommodation.aire.name': 'Villa Aire',
  'accommodation.aire.element': 'Air Element',
  'accommodation.aire.description': 'Light and airy, designed for freedom and movement with open spaces and panoramic views.',
  'accommodation.agua.name': 'Villa Agua',
  'accommodation.agua.element': 'Water Element',
  'accommodation.agua.description': 'Flowing with tranquility and grace, featuring calming blue tones and soothing water features.',
  'accommodation.eter.name': 'Villa Eter',
  'accommodation.eter.element': 'Ether Element',
  'accommodation.eter.description': 'Connecting with the infinite, a space for deep contemplation and spiritual awakening.',
  'accommodation.cta': 'View Details',

  // Reservation Section
  'reservation.title': 'Reserve Your Retreat',
  'reservation.subtitle': 'Begin Your Transformation Journey',
  'reservation.name': 'Full Name',
  'reservation.email': 'Email Address',
  'reservation.phone': 'Phone Number',
  'reservation.duration': 'Retreat Duration',
  'reservation.duration.7days': '7 Days',
  'reservation.duration.14days': '14 Days',
  'reservation.duration.21days': '21 Days',
  'reservation.date': 'Preferred Start Date',
  'reservation.villa': 'Villa Preference',
  'reservation.villa.any': 'Any',
  'reservation.villa.tierra': 'Villa Tierra',
  'reservation.villa.fuego': 'Villa Fuego',
  'reservation.villa.aire': 'Villa Aire',
  'reservation.villa.agua': 'Villa Agua',
  'reservation.villa.eter': 'Villa Eter',
  'reservation.message': 'Message (Optional)',
  'reservation.message.placeholder': 'Tell us about your health goals and any special requirements...',
  'reservation.submit': 'Submit Reservation',
  'reservation.submitting': 'Submitting...',
  'reservation.success': 'Thank you! Your reservation has been received. We\'ll contact you soon.',
  'reservation.error': 'Something went wrong. Please try again.',

  // Footer
  'footer.tagline': 'Your journey to holistic wellness begins here',
  'footer.quick_links': 'Quick Links',
  'footer.connect': 'Connect',
  'footer.email': 'Email',
  'footer.phone': 'Phone',
  'footer.whatsapp': 'WhatsApp',
  'footer.instagram': 'Instagram',
  'footer.copyright': '© 2025 Swasthya Ayurvedic Retreat. All rights reserved.',

  // Villa Details
  'villa.amenities': 'Amenities',
  'villa.amenity.bed': 'King Size Bed',
  'villa.amenity.bathroom': 'Luxury Private Bathroom',
  'villa.amenity.view': 'Panoramic View',
  'villa.amenity.meditation': 'Meditation Space',
  'villa.amenity.terrace': 'Private Terrace',
  'villa.amenity.ac': 'Air Conditioning',
  'villa.book': 'Book This Villa',
  'villa.back': 'Back to Home',
};
